import script from "./LoginC.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginC.vue?vue&type=script&setup=true&lang=js"

import "./LoginC.vue?vue&type=style&index=0&id=6f05063c&lang=less"

const __exports__ = script;

export default __exports__